import { c as _c } from "react/compiler-runtime";
import { MAX_SKILLS_PER_SESSION, type UsedSkill } from '@shared/all/domains/skills';
import { useReducer } from 'react';

// The skills picked for the next research message (.specs/skills.md), for every
// research input: Oakbox Ask on web and phone, factiii.com research on web and
// mobile. One copy of the dedupe and the cap, which the server enforces too
// (research.start/reply take at most MAX_SKILLS_PER_SESSION).

type Action = {
  type: 'add';
  skill: UsedSkill;
} | {
  type: 'remove';
  uuid: string;
} | {
  type: 'clear';
};
const reducer = (picks: UsedSkill[], action: Action): UsedSkill[] => {
  switch (action.type) {
    case 'add':
      return [...picks, action.skill];
    case 'remove':
      return picks.filter(p => p.uuid !== action.uuid);
    case 'clear':
      return [];
  }
};
const useSkillPicks = () => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [picks, dispatch] = useReducer(reducer, t0);
  let t1;
  if ($[1] !== picks) {
    t1 = uuid => picks.some(p => p.uuid === uuid);
    $[1] = picks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const has = t1;
  let t2;
  if ($[3] !== has || $[4] !== picks) {
    t2 = skill => {
      if (has(skill.uuid)) {
        return true;
      }
      if (picks.length >= MAX_SKILLS_PER_SESSION) {
        return false;
      }
      dispatch({
        type: "add",
        skill
      });
      return true;
    };
    $[3] = has;
    $[4] = picks;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const add = t2;
  let t3;
  if ($[6] !== add || $[7] !== has) {
    t3 = skill_0 => {
      if (!has(skill_0.uuid)) {
        return add(skill_0);
      }
      dispatch({
        type: "remove",
        uuid: skill_0.uuid
      });
      return true;
    };
    $[6] = add;
    $[7] = has;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = uuid_0 => dispatch({
      type: "remove",
      uuid: uuid_0
    });
    t5 = () => dispatch({
      type: "clear"
    });
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[11] !== add || $[12] !== picks || $[13] !== t3) {
    t6 = {
      picks,
      add,
      toggle: t3,
      remove: t4,
      clear: t5
    };
    $[11] = add;
    $[12] = picks;
    $[13] = t3;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default useSkillPicks;